import { ReactNode, createContext, useContext, useState } from 'react';

type CompanyProfileFields = {
  makeFieldsVisible: boolean;
  setMakeFieldsVisible: (makeFieldsVisible: boolean) => void;
  fromReviewPage: boolean;
  setFromReviewPage: (makeFieldsVisible: boolean) => void;
};

export const CompanyProfileFieldsContext = createContext<CompanyProfileFields>({
  makeFieldsVisible: false,
  setMakeFieldsVisible: () => {},
  fromReviewPage: false,
  setFromReviewPage: () => {},
});

export const CompanyProfileFieldsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [makeFieldsVisible, setMakeFieldsVisible] = useState<boolean>(false);
  const [fromReviewPage, setFromReviewPage] = useState<boolean>(false);

  return (
    <CompanyProfileFieldsContext.Provider
      value={{
        makeFieldsVisible,
        setMakeFieldsVisible,
        fromReviewPage,
        setFromReviewPage,
      }}
    >
      {children}
    </CompanyProfileFieldsContext.Provider>
  );
};

export const useCompanyProfileFields = (): CompanyProfileFields => useContext(CompanyProfileFieldsContext);
